/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference, FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceFromJSONTyped, FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference';
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference(json)) {
        return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreference(value)) {
        return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptionsPowerPreferenceToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreference.js.map